import { useLocation } from 'react-router-dom';
import { useGetTopicByIDQuery } from '../slices/topicsApiSlice';
import LoaderArticle from '../features/skeletons/LoaderArticle';

export const useTopic = () => {
  const location = useLocation();
  const id_topic = location.pathname.replace(/^(.+)\/(\d+)$/, '$2');
  const { data: topic, isLoading, isSuccess, isError, error } = useGetTopicByIDQuery(id_topic);

  const LoadingComponent = () => (
    <LoaderArticle />
  );

  return {
    topic,
    isLoading,
    isSuccess,
    isError,
    error,
    LoadingComponent
  };
};